import { IUser } from '@contexts/AuthContext/type';

export const getAccess = (slug: string, user: IUser) => {
  const userAccess = user?.data?.access?.online_library;
  return !!userAccess && userAccess.some(obj => obj.slug === slug);
};